
























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LineStrokeTypeController extends Vue 
{
    @Prop() layer! : LineLayer;

    private isValue(value : number)
    {
        return this.layer.strokeType == value;
    }

    private setValue(value : number)
    {
        this.changeLayerProperty("strokeType", value, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
